import { useEffect, useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";

const WhatsAppIcon = ({ size = 26 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.296-.767.967-.94 1.164-.173.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.695.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.288.173-1.413-.074-.124-.272-.198-.57-.347zM12.04 21.5h-.003a9.87 9.87 0 01-5.031-1.378l-.36-.214-3.74.98 1.001-3.643-.235-.374a9.86 9.86 0 01-1.51-5.26c0-5.45 4.436-9.884 9.888-9.884a9.82 9.82 0 016.992 2.898 9.825 9.825 0 012.893 6.994c-.002 5.45-4.437 9.884-9.886 9.884zM20.52 3.449C18.246 1.245 15.226.012 12.014 0 5.4 0 .021 5.378.018 11.987c0 2.111.55 4.176 1.601 6L0 24l6.17-1.62a11.95 11.95 0 005.836 1.49h.005c6.61 0 11.992-5.379 11.994-11.987 0-3.205-1.244-6.218-3.495-8.434z" />
  </svg>
);

const sanitize = (num) =>
  (num || "")
    .replace(/[^\d+]/g, "")
    .replace(/^00/, "+")
    .replace(/^\+/, "");

const WhatsAppButton = () => {
  const { t, lang } = useLanguage();
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    api
      .get("/site/content")
      .then((r) => {
        const sc = r.data || {};
        const wp = sanitize(sc.whatsapp_number || sc.contact_phone || "");
        setNumber(wp);
        const msg = (sc.whatsapp_message && (sc.whatsapp_message[lang] || sc.whatsapp_message.tr)) || "";
        setMessage(msg);
      })
      .catch(() => {});
  }, [lang]);

  if (!number) return null;
  const href = `https://wa.me/${number}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-cta"
      aria-label="WhatsApp"
      className="fixed z-30 right-5 bottom-24 md:bottom-6 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.45)] hover:bg-[#1FAE54] hover:scale-105 transition-all duration-300"
    >
      <WhatsAppIcon size={26} />
      <span className="sr-only">{t("nav.book")}</span>
    </a>
  );
};

export default WhatsAppButton;
